import { render } from "./ClosedLoop.vue?vue&type=template&id=4da36116&scoped=true"
import script from "./ClosedLoop.vue?vue&type=script&lang=js"
export * from "./ClosedLoop.vue?vue&type=script&lang=js"

import "./ClosedLoop.vue?vue&type=style&index=0&id=4da36116&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da36116"]])

export default __exports__